<div class="d-flex">
  <div class="d-flex flex-wrap align-items-center justify-content-between w-100">
    <div class="d-flex flex-grow-1">
      <base-search
        class="me-3"
        placeholder="search.forCandidates"
        [value]="activatedRoute.snapshot.queryParams.search"
        [useEnterEvent]="true"
        (query)="onSearchChange($event)"
      ></base-search>
      <div>
        <ng-container [ngTemplateOutlet]="widgetTemplate"></ng-container>
      </div>
    </div>
    <div class="d-flex flex-grow-1 justify-content-end">
      <div
        class="d-flex align-items-center mt-2 mt-sm-0 gap-2 me-4 pointer headline-menu-item"
        (click)="showFilters()"
      >
        <div
          *ngIf="!isFiltersVisible && activeFiltersAmount"
          class="circle-sm bg-danger filters-amount"
        >
          {{ activeFiltersAmount }}
        </div>
        <i class="fa-solid fa-filter"></i>
        <p class="font-weight-bold m-0">
          {{ 'filter.singular' | translate }}
        </p>
      </div>
      <div
        class="d-flex align-items-center mt-2 mt-sm-0 gap-2 pointer headline-menu-item"
        (click)="showLegend()"
      >
        <i class="fa-solid fa-rectangle-list"></i>
        <p class="font-weight-bold m-0">
          {{ (isLegendVisible ? 'inquiry.hideLegend' : 'inquiry.showLegend') | translate }}
        </p>
      </div>
      <base-customer-sort-filter-dropdown
        [placeholder]="activeSortFilterLabel ? activeSortFilterLabel : 'action.sort'"
        [items]="baseInquirySortingOptions"
        [activeOrderDirection]="activeSortOrderDirection"
        (listItemClicked)="onSortItemClicked($event)"
      ></base-customer-sort-filter-dropdown>
      <base-button
        label="inquiry.showInquiryInfo"
        color="primary"
        class="d-flex align-items-center mt-2 mt-sm-0 gap-2 ms-xs-4 ms-sm-0 ms-md-4"
        (btnClick)="showSidebar()"
      ></base-button>
    </div>
  </div>
</div>
<div
  class="mt-3"
  *ngIf="isFiltersVisible"
>
  <base-customer-inquiry-offers-list-filters
    [branches]="branches"
    [qualifications]="mainQualifications"
    [filtersForm]="filtersForm"
  ></base-customer-inquiry-offers-list-filters>
</div>
<div
  *ngIf="isLegendVisible"
  class="d-flex justify-content-end"
>
  <div
    class="d-flex align-items-center mt-3 ms-2 ms-xl-3"
    *ngFor="let legendItem of legend"
  >
    <i
      class="fa-solid fa-circle me-2"
      [ngClass]="legendItem.icon"
      placement="top"
      [ngbTooltip]="'shiftStatus.legend.' + legendItem.status | translate"
    ></i>
    <span
      class="d-none d-lg-block {{ 'text-' + legendItem.status }}"
      baseTruncate
      >{{ 'shiftStatus.legend.' + legendItem.status | translate }}</span
    >
  </div>
</div>
